<template>
    <div class="field__toggle">
        <input
            type="checkbox"
            v-bind="{
                ...$attrs,
                ...( !allowFilling && { disabled: true })
            }"
            class="field__toggle__input display--none"
            :checked="checked"
            v-on="{
                ...( allowFilling && {
                    change: toggle
                })
            }"
        />
        <label
            :for="$attrs.id"
            :class="[
                'field__toggle__label position--relative display--block',
                { 'pointer': allowFilling }
            ]" >
        </label>
    </div>
</template>

<script>
// packages
import { ref } from '@vue/composition-api';

// hooks
import { reset } from '@/hooks/use-input-listeners';

export default {
    inheritAttrs: false,
    props: {
        reset: Boolean,
        defaultValue: Number,
        allowFilling: {
            type: Boolean,
            default: true
        }
    },
    setup ( props, { emit }) {
        const checked = ref( props.defaultValue );

        // listener para quando for necessário
        // proceder a um reset a input.
        reset({ props, object: checked, key: 'value' });

        const toggle = event => {
            checked.value = event.target.checked ? 1 : 0;

            emit( 'input', checked.value );
        };

        return { checked, toggle };
    }
};
</script>